export const summaryBundle = {
  rank: { ko: "전체 순위", en: "Ranking", es: "Clasificacion" },
  usageRank: { ko: "사용량 순위", en: "Usage Rank", es: "Rango de uso" },
  info: {
    ko: "{dong}동 {ho}호 최근 한 달 사용량 정보",
    en: "{dong} {ho} Usage Overview for the Past Month",
    es: "Resumen del uso de {dong} {ho} durante el último mes"
  },
  groupAverage: {
    ko: "단지 평균 사용량",
    en: "Complex Average Usage",
    es: "Uso promedio del complejo"
  },
  myUsage: { ko: "우리 집 사용량", en: "My Usage", es: "Mi uso" },
  overuse: {
    ko: "우리집이 약 {percent}% 만큼 더 사용하고 있어요.",
    en: "Your household uses about {percent}% more.",
    es: "Su hogar consume aproximadamente un {percent}% mas."
  },
  underuse: {
    ko: "우리집이 약 {percent}% 만큼 덜 사용하고 있어요.",
    en: "Your household uses about {percent}% less.",
    es: "Su hogar consume aproximadamente un {percent}% menos."
  },
  avg: { ko: "평균 수준", en: "Average", es: "Promedio" },
  high: { ko: "사용량 높음", en: "High Usage", es: "Uso alto" },
  low: { ko: "절약 중", en: "Efficient", es: "Eficiente" },
  selectDongFirst: {
    ko: "동을 먼저 선택해주세요",
    en: "Please select a building (Dong) first",
    es: "Seleccione primero un edificio."
  },
  selectHoFirst: {
    ko: "호를 먼저 선택해주세요",
    en: "Please select a unit (Ho) first",
    es: "Seleccione primero una unidad."
  }
}
